<template>
  <div>
    <div class="page">
      <div class="greement-head">
        请先阅读相关隐私协议
        <br />再使用该应用！
      </div>
      <div v-if="!iosflag" class="arreement">
          
        <p
          class="desc"
        >感谢您信任并使用本应用的产品和服务，我们根据最新的法律法规、监管政策要求制定了改协议，希望您仔细阅读《隐私政策》（以下简称“本政策”），详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并作出适当的选择。 若您使用本应用，即表示您认同我们在本政策中所述内容。除另有约定外，本政策所用术语与本应用其他协议中的术语具有相同的涵义。</p>
        <p
          class="desc"
        >特别说明：我们有使用技术手段过滤令人反感的内容，一旦发现该有用户发布和传播有害的、令人反感的内容，我们将依法停止传输任何前述内容并采取相应行动，包括但不限于暂停违规用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。</p>
        <p class="title_small">一、我们收集的信息</p>
        <p class="desc">
          我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。 您在使用我们服务时主动提供的信息、您在注册帐户时填写的信息；例如，您在注册帐户时所填写的昵称、手机号码。 您在使用服务时上传的信息；例如，您在使用时，上传的头像、分享的照片，
          即时通讯内容、图片、文字、视频等。 您通过我们的客服或参加我们举办的活动时所提交的信息，例如，您参与我们线上活动时填写的调查问卷中可能包含您的姓名、电话、家庭地址等信息。我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。
          我们在您使用服务时获取的信息。
        </p>
        <p class="desc">
          1、日志信息：当您使用我们的服务时，我们可能会自动收集相关信息并存储为服务日志信息。（1）设备信息；例如，设备型号、操作系统版本、唯一设备标识符、电池、信号强度等信息。（2）软件信息；例如，软件的版本号、浏览器类型。为确保操作环境的安全或提供服务所需，我们会收集有关您使用的移动应用和其他软件的信息。（3）IP地址（4）服务日志信息；例如，您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。（5）通讯信息；例如，您在使用我们服务时曾经通讯的账户、通讯时间、内容和时长。
          位置信息：当您使用与位置有关的服务时，我们会记录您设备所在的位置信息，以便为您提供相关服务。在您使用服务时，我们可能会通过IP地址 、GPS、WLAN（如 WiFi)或基站等途径获取您的地理位置信息；您或其他用户在使用服务时提供的信息中可能包含您所在地理位置信息，例如您提供的帐号信息中可能包含的您所在地区信息，您或其他人共享的照片包含的地理标记信息。
        </p>
        <p
          class="desc"
        >2、其他相关信息：为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。例如，我们收集的好友列表、群列表信息、声纹特征值信息。为确保您使用我们服务时能与您认识的人进行联系，如您选择开启导入通讯录功能，我们可能对您联系人的姓名和电话号码进行加密，并仅收集加密后的信息。其他用户分享的信息中含有您的信息；例如，其他用户发布的照片或分享的视频中可能包含您的信息。 从第三方合作伙伴获取的信息：我们可能会获得您在使用第三方合作伙伴服务时所产生或分享的信息。例如，您使用微信或QQ帐户登录第三方合作伙伴服务时，我们会获得您登录第三方合作伙伴服务的名称、登录时间，方便您进行授权管理。请您仔细阅读第三方合作伙伴服务的用户协议或隐私政策。</p>

        <p class="title_small">二、我们如何使用收集的信息</p>
        <p class="desc">
          我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。向您提供服务、满足您的个性化需求，例如，语言设定、位置设定、个性化的帮助服务。产品开发和服务优化 ，
          例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。安全保障，例如，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。例如，您下载或安装的安全软件会对恶意程序或病毒进行检测，或为您识别诈骗信息。您推荐您可能感兴趣的广告、资讯等；评估、改善我们的广告投放和其他促销及推广活动的效果；管理软件，例如，进行软件认证、软件升级等。邀请您参与有关我们服务的调查,为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告、用于用户研究分析与统计等服务.为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，您使用应用程序的频率、故障信息、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。
        </p>

        <p class="title_small">三、我们如何使用cookie及相关技术</p>
        <p class="desc">
          我们或我们的第三方合作伙伴，可能通过放置安全的Cookie及相关技术收集您的信息，目的是为您提供更个性化的用户体验和服务。我们会严格要求第三方合作伙伴遵守本政策的相关规定。您也可以通过浏览器设置管理Cookie。但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。若您希望了解更多Cookie的安全性等信息，可参见《Cookie政策说明》。
          您分享的信息：您可以通过我们的服务与您的好友、家人及其他用户分享您的相关信息。例如，您在应用中公开的文字和照片。 请注意，这其中可能包含您的个人身份信息、个人财产信息等敏感信息。请您谨慎考虑披露您的相关个人敏感信息。您可删除您公开的信息。但请您注意，这些信息仍可能由其他用户或不受我们控制的非关联第三方独立地保存。
        </p>

        <p class="title_small">四、您如何管理自己的信息</p>
        <p
          class="desc"
        >您可以在使用我们服务的过程中，访问、修改和删除您提供的注册信息和其他个人信息，也可按照通知指引与我们联系。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。例如，若您在使用地理位置相关服务时，希望停止分享您的地理位置信息，您可通过手机定位关闭功能、软硬件服务商及通讯服务提供商的关闭方式停止分享。我们将按照本政策所述，仅为实现我们产品或服务的功能，收集、使用您的信息。如您发现我们违反法律、行政法规的规定或者双方的约定收集、使用您的个人信息，您可以要求我们删除。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。</p>

        <p class="title_small">五、我们分享的信息</p>
        <p class="desc">
          我们遵照法律法规的规定，对信息的分享进行严格的限制，经您事先同意，我们可能与第三方分享您的个人信息，仅为实现外部处理的目的，我们可能会与第三方合作伙伴（第三方服务供应商、承包商、代理、广告合作伙伴、应用开发者等，例如，代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置服务的地图服务供应商）（他们可能并非位于您所在的法域）分享您的个人信息，让他们按照我们的说明、隐私政策以及其他相关的保密和安全措施来为我们处理上述信息，并用于以下用途：向您提供我们的服务； 实现“我们如何使用收集的信息”部分所述目的；履行我们的义务和行使我们的权利；理解、维护和改善我们的服务。如我们与上述第三方分享您的信息，我们将会采用加密、匿名化处理等手段保障您的信息安全。
          随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向第三方分享您的个人信息时，我们将通过推送通知、公告等形式告知您相关情形，按照法律法规及不低于本政策所要求的标准继续保护或要求新的管理者继续保护您的个人信息。 我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的城市热力图或行业洞察报告。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。 我们可能基于以下目的披露您的个人信息：遵守适用的法律法规等有关规定；遵守法院判决、裁定或其他法律程序的规定；遵守相关政府机关或其他法定授权组织的要求；我们有理由确信需要遵守法律法规等有关规定；为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益合理且必要的用途。
        </p>

        <p
          class="desc"
        >六、我们可能向您发送的信息 ：信息推送，您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知。您可以按照我们的相关提示，在设备上选择取消订阅。与服务有关的公告：我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于广告的公告。</p>

        <p class="desc">
          七、存储信息的地点和期限：存储信息的地点，我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。存储信息的期限：一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：为遵守适用的法律法规等有关规定；为遵守法院判决、裁定或其他法律程序的规定；
          为遵守相关政府机关或法定授权组织的要求；我们有理由确信需要遵守法律法规等有关规定；·为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。
        </p>

        <p class="title_small">八、信息安全</p>
        <p
          class="desc"
        >我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露。我们严格遵守法律法规保护用户的通信秘密。 我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。 例如，我们使用加密技术、匿名化处理等手段来保护您的个人信息。我们建立专门的管理制度、流程和组织确保信息安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。</p>

        <p class="title_small">九、广告</p>
        <p class="desc">我们可能使用您的相关信息，在相关网站、应用及其他渠道向您提供与您更加相关的广告。您可以在关于广告页面中了解更多。</p>

        <p class="title_small">十、未成年人保护</p>
        <p class="desc">我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用腾讯的服务前，应事先取得您的家长或法定监护人的同意。</p>

        <p class="title_small">十一、适用范围</p>
        <p
          class="desc"
        >我们的所有服务均适用本政策。某些服务有其特定的隐私指引/声明，该特定隐私指引/声明更具体地说明我们在该服务中如何处理您的信息。如本政策与特定服务的隐私指引/声明有不一致之处，请以该特定隐私指引声明为准。请您注意，本政策不适用由其他公司或个人提供的服务。例如，您通过使用本应用帐号登录其他公司或个人提供的服务。您使用该等第三方服务须受其隐私政策（而非本政策）约束，您需要仔细阅读其政策内容。</p>

       <p class="title_small">十二、账号注销</p>
      <p class="desc">您可以通过APP右下角 >我的 >点击头像进入个人中心 >注销账号选项处注销您的账号。请您注意，账号注销后将不可被使用且该账号信息将被删除，您将无法再通过该账号登录（但不会影响您使用无需账号登录即可使用的服务和功能），因此请您谨慎操作。为了保护您或他人的合法权益，我们会结合您对深圳市无间数码科技有限公司各产品或服务的使用情况判断是否支持您的注销请求。若您存在不适合注销账号的情形，则我们不会立即支持您的请求。当您注销账号后，除法律法规要求我们保存相关信息的情况外，我们将停止为您提供相应的产品或服务。</p>


        <p class="title_small">十三、联系我们</p>
        <p class="desc">如您对本政策或其他相关事宜有疑问，请通过应用内的反馈功能与我们联系，我们将尽快审核所涉问题，并在验证您的用户身份后予以回复。</p>

        <p class="title_small">十四、变更</p>
        <p
          class="desc"
        >我们可能适时修订本政策内容。如该等变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。</p>
        
        <p class="desc-com">单词乐运营团队</p>

      </div>

       <div v-if="iosflag" class="arreement">
                 <p class="desc">学习乐app是由深圳市无间数码科技有限公司开发的一款背单词软件</p>

    <p
        class="desc"
      >感谢您信任并使用本应用的产品和服务，我们根据最新的法律法规、监管政策要求制定了改协议，希望您仔细阅读《隐私政策》（以下简称“本政策”），详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并作出适当的选择。 若您使用本应用，即表示您认同我们在本政策中所述内容。除另有约定外，本政策所用术语与本应用其他协议中的术语具有相同的涵义。</p>
      <p
        class="desc"
      >特别说明：我们有使用技术手段过滤令人反感的内容，一旦发现该有用户发布和传播有害的、令人反感的内容，我们将依法停止传输任何前述内容并采取相应行动，包括但不限于暂停违规用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。</p>
      <p class="title_small">一、我们收集的信息</p>
      <p
        class="desc"
      >我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。 您在使用我们服务时主动提供的信息、您在注册帐户时填写的信息；例如，您在注册帐户时所填写的昵称、手机号码。 您在使用服务时上传的信息；例如，您在使用时，上传的头像、分享的照片，即时通讯内容、图片、文字、视频等。 您通过我们的客服或参加我们举办的活动时所提交的信息，例如，您参与我们线上活动时填写的调查问卷中可能包含您的姓名、电话、家庭地址等信息。我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。</p>
      <p class="desc">我们在您使用服务时获取的信息。</p>
      <p class="desc">
        1、日志信息：当您使用我们的服务时，我们可能会自动收集相关信息并存储为服务日志信息。（1）设备信息；例如，设备型号、操作系统版本、唯一设备标识符、电池、信号强度等信息。（2）软件信息；例如，软件的版本号、浏览器类型。为确保操作环境的安全或提供服务所需，我们会收集有关您使用的移动应用和其他软件的信息。（3）IP地址（4）服务日志信息；例如，您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。（5）通讯信息；例如，您在使用我们服务时曾经通讯的账户、通讯时间、内容和时长。
        位置信息：当您使用与位置有关的服务时，我们会记录您设备所在的位置信息，以便为您提供相关服务。在您使用服务时，我们可能会通过IP地址 、GPS、WLAN（如 WiFi)或基站等途径获取您的地理位置信息；您或其他用户在使用服务时提供的信息中可能包含您所在地理位置信息，例如您提供的帐号信息中可能包含的您所在地区信息，您或其他人共享的照片包含的地理标记信息。
      </p>
      <p
        class="desc"
      >2、其他相关信息：为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。例如，我们收集的好友列表、群列表信息、声纹特征值信息。为确保您使用我们服务时能与您认识的人进行联系，如您选择开启导入通讯录功能，我们可能对您联系人的姓名和电话号码进行加密，并仅收集加密后的信息。其他用户分享的信息中含有您的信息；例如，其他用户发布的照片或分享的视频中可能包含您的信息。 从第三方合作伙伴获取的信息：我们可能会获得您在使用第三方合作伙伴服务时所产生或分享的信息。例如，您使用微信或QQ帐户登录第三方合作伙伴服务时，我们会获得您登录第三方合作伙伴服务的名称、登录时间，方便您进行授权管理。请您仔细阅读第三方合作伙伴服务的用户协议或隐私政策。</p>
      <p class="title_small">二、我们如何使用收集的信息</p>
      <p class="desc">
        我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。向您提供服务、满足您的个性化需求，例如，语言设定、位置设定、个性化的帮助服务。产品开发和服务优化 ，
        例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。安全保障，例如，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。例如，您下载或安装的安全软件会对恶意程序或病毒进行检测，或为您识别诈骗信息。您推荐您可能感兴趣的广告、资讯等；评估、改善我们的广告投放和其他促销及推广活动的效果；管理软件，例如，进行软件认证、软件升级等。邀请您参与有关我们服务的调查,为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告、用于用户研究分析与统计等服务.为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，您使用应用程序的频率、故障信息、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。
      </p>
      <p class="title_small">三、我们如何使用cookie及相关技术</p>
      <p class="desc">
        我们或我们的第三方合作伙伴，可能通过放置安全的Cookie及相关技术收集您的信息，目的是为您提供更个性化的用户体验和服务。我们会严格要求第三方合作伙伴遵守本政策的相关规定。您也可以通过浏览器设置管理Cookie。但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。若您希望了解更多Cookie的安全性等信息，可参见《Cookie政策说明》。
        您分享的信息：您可以通过我们的服务与您的好友、家人及其他用户分享您的相关信息。例如，您在应用中公开的文字和照片。 请注意，这其中可能包含您的个人身份信息、个人财产信息等敏感信息。请您谨慎考虑披露您的相关个人敏感信息。您可删除您公开的信息。但请您注意，这些信息仍可能由其他用户或不受我们控制的非关联第三方独立地保存。
      </p>
      <p class="title_small">
        四、您如何管理自己的信息
        您可以在使用我们服务的过程中，访问、修改和删除您提供的注册信息和其他个人信息，也可按照通知指引与我们联系。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。例如，若您在使用地理位置相关服务时，希望停止分享您的地理位置信息，您可通过手机定位关闭功能、软硬件服务商及通讯服务提供商的关闭方式停止分享。我们将按照本政策所述，仅为实现我们产品或服务的功能，收集、使用您的信息。如您发现我们违反法律、行政法规的规定或者双方的约定收集、使用您的个人信息，您可以要求我们删除。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。
      </p>
      <p class="title_small">五、我们分享的信息</p>
      <p
        class="desc"
      >我们遵照法律法规的规定，对信息的分享进行严格的限制，经您事先同意，我们可能与第三方分享您的个人信息，仅为实现外部处理的目的，我们可能会与第三方合作伙伴（第三方服务供应商、承包商、代理、广告合作伙伴、应用开发者等，例如，代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置服务的地图服务供应商）（他们可能并非位于您所在的法域）分享您的个人信息，让他们按照我们的说明、隐私政策以及其他相关的保密和安全措施来为我们处理上述信息，并用于以下用途：向您提供我们的服务； 实现“我们如何使用收集的信息”部分所述目的；履行我们的义务和行使我们的权利；理解、维护和改善我们的服务。如我们与上述第三方分享您的信息，我们将会采用加密、匿名化处理等手段保障您的信息安全。 随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向第三方分享您的个人信息时，我们将通过推送通知、公告等形式告知您相关情形，按照法律法规及不低于本政策所要求的标准继续保护或要求新的管理者继续保护您的个人信息。 我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的城市热力图或行业洞察报告。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。 我们可能基于以下目的披露您的个人信息：遵守适用的法律法规等有关规定；遵守法院判决、裁定或其他法律程序的规定；遵守相关政府机关或其他法定授权组织的要求；我们有理由确信需要遵守法律法规等有关规定；为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益合理且必要的用途。</p>
      <p
        class="title_small"
      >六、我们可能向您发送的信息 ：信息推送，您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知。您可以按照我们的相关提示，在设备上选择取消订阅。与服务有关的公告：我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于广告的公告。</p>
      <p class="title_small">
        七、存储信息的地点和期限：存储信息的地点，我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。存储信息的期限：一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：为遵守适用的法律法规等有关规定；为遵守法院判决、裁定或其他法律程序的规定；
        为遵守相关政府机关或法定授权组织的要求；我们有理由确信需要遵守法律法规等有关规定；·为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。
      </p>
      <p class="title_small">八、信息安全</p>
      <p
        class="desc"
      >我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露。我们严格遵守法律法规保护用户的通信秘密。 我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。 例如，我们使用加密技术、匿名化处理等手段来保护您的个人信息。我们建立专门的管理制度、流程和组织确保信息安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。</p>
      <p class="title_small">九、广告</p>
      <p class="desc">我们可能使用您的相关信息，在相关网站、应用及其他渠道向您提供与您更加相关的广告。您可以在关于广告页面中了解更多。</p>
      <p class="title_small">十、未成年人保护</p>
      <p class="desc">我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用腾讯的服务前，应事先取得您的家长或法定监护人的同意。</p>
      <p class="title_small">十一、适用范围</p>
      <p
        class="desc"
      >我们的所有服务均适用本政策。某些服务有其特定的隐私指引/声明，该特定隐私指引/声明更具体地说明我们在该服务中如何处理您的信息。如本政策与特定服务的隐私指引/声明有不一致之处，请以该特定隐私指引声明为准。请您注意，本政策不适用由其他公司或个人提供的服务。例如，您通过使用本应用帐号登录其他公司或个人提供的服务。您使用该等第三方服务须受其隐私政策（而非本政策）约束，您需要仔细阅读其政策内容。</p>
      <p class="title_small">十二、联系我们</p>
      <p class="desc">如您对本政策或其他相关事宜有疑问，请通过应用内的反馈功能与我们联系，我们将尽快审核所涉问题，并在验证您的用户身份后予以回复。</p>
      <p class="title_small">十二、变更</p>
      <p
        class="desc"
      >我们可能适时修订本政策内容。如该等变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。</p>
      
    </div>

      <div  class="page-foot">
        <p><a @click="colseQuitView(2)" class="page-footbty">不同意</a></p>
        <p><a @click="colseQuitView(1)" class="page-footty">同意开始</a></p>
      </div>
     
    </div>
    <div class="back"></div>
    <div class="toast" v-show="toastShow">
				{{toastText}}
		</div>
  </div>
  
</template>
<script>
import headBack from "../common/head-back-no-refresh";
import store from "@/store";

export default {
  name: "app",
  data() {
    return {
      msg: "隐私协议",
      iosflag:true,
      toastShow: false,
			toastText: '',
			username: '显示消息提示框'
    };
  },

  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
  },
  methods: {

    colseQuitView:function(type) {
      if(type==1){
         window.location.href = "hqml://setStorage?key=h5_privacy_agree&value=1";
            setTimeout(function() {
              window.location.href = "hqml://closeWindow";
            }, 300);
      }else{
        //window.location.href = "hqml://quitApp";
        
         		let v = this
						v.toastText = "同意后即可使用单词乐"
						v.toastShow = true
						setTimeout(function() {
							v.toastShow = false
						}, 1500);
            
           //alert("ok")
      }
      
    }
  },
  created() {
    var ua = navigator.userAgent;
    console.log(ua.indexOf("T00991")+"0000")
    if (ua.indexOf("T00991") > -1) {
      this.iosflag = true;
    } else {
      this.iosflag = false;
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 100%;
}
.back {
  width: 100%;
  height: 120%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
}
.greement-head{
  width: 100%;
  height: 132px;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 48px;
  color: #FFFFFF;
  opacity: 1;
  background: url('../../assets/img/agreement-head.png');
  text-align: center;
  background-size: 100%;
  padding-top: 28px;
}
.page {
  width: 540px;
  height: 1100px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 1000;
}
.page-foot {
  width: 74px;
  height: 116px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  bottom: 0;
  width: 100%;
}
.page-footty{
  display: block;
  width: 449px;
  height: 80px;
  background: linear-gradient(180deg, #2D50ED 0%, #4EA0FE 100%);
  box-shadow: 0px 4px 12px #CADEFF;
  opacity: 1;
  border-radius: 10px;
  line-height: 80px;
  margin: 0px auto 0 auto;
}
.page-foot2 {
  width: 74px;
  height: 116px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  position: fixed;
  bottom: 0;
  width: 100%;
}
.page-footbty{
  display: block;
  width: 449px;
  height: 80px;
  background: linear-gradient(180deg, #f2f3f7 0%, #abcdf3 100%);
  box-shadow: 0px 4px 12px #CADEFF;
  opacity: 1;
  border-radius: 10px;
  line-height: 80px;
  margin: 0px auto 0 auto;
}
.arreement {
  padding: 0px 36px 80px 50px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
  height: 610px;
  background: #F7F7F7;
  border-radius: 16px;
  overflow: scroll;
}

.title {
  padding: 48px 50px 10px 50px;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 50px;
}
.arreement p {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
  text-align: left;
}
.arreement .arreement .title {
  text-align: left;
  padding-bottom: 30px;
  font-weight: bold;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: rgba(48, 48, 48, 1);
  line-height: 44px;
}
.arreement .title_small {
  padding-top: 20px;
  line-height: 26px;
}

.arreement span {
  color: red;
  text-decoration: underline red;
}

.arreement .bold {
  font-weight: bold;
}
.arreement .text_line {
  text-decoration: underline;
}
.desc-com{
  text-align: center;
}
.toast {
			position: fixed;
			z-index: 2000;
			left: 50%;
			top: 45%;
			transition: all .5s;
			-webkit-transform: translateX(-50%) translateY(-50%);
			-moz-transform: translateX(-50%) translateY(-50%);
			-ms-transform: translateX(-50%) translateY(-50%);
			-o-transform: translateX(-50%) translateY(-50%);
			transform: translateX(-50%) translateY(-50%);
			text-align: center;
			border-radius: 5px;
			color: #FFF;
			background: rgba(17, 17, 17, 0.7);
			height: 60px;
			line-height: 45px;
			padding: 0 15px;
			max-width: 350px;
		}
</style>




// WEBPACK FOOTER //
// src/components/agreement/qmlprivacyAgreeShow2.vue